"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostShowEmailPreviewData = void 0;
const creator_1 = require("../creator");
const getPostShowEmailPreviewData = (config, builderId, draftId, assetsEndpoint) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { selectedColors } = (0, creator_1.getColorConfig)(config);
    const imageVariant = config.fields.type.content === 0
        ? "c"
        : [1, 3, 4].includes(config.fields.type.content)
            ? "b"
            : "a";
    const bannerUrl = `${assetsEndpoint}/preview/${builderId}/${draftId}/${imageVariant}`;
    const sociallinks = (0, creator_1.getSocialLinks)(config);
    const filteredSocialLinks = Object.fromEntries(Object.entries(sociallinks).filter(([k, v]) => !!v));
    const selectedMerchandise = !config.fields.postShowEmailMerchEnabled.content
        ? []
        : ((_a = config.fields.merchandise.content) === null || _a === void 0 ? void 0 : _a.filter((m) => m.isSelected)) || [];
    return {
        artistName: config.artistName || "",
        eventId: builderId,
        selectedColors: selectedColors || { dark: "#666", light: "#fff" },
        eventType: config.fields.type.content,
        bannerUrl,
        ...(!!(selectedMerchandise === null || selectedMerchandise === void 0 ? void 0 : selectedMerchandise.length) && {
            merch: {
                header: ((_b = config.fields.postShowEmailMerchHeadline.content) === null || _b === void 0 ? void 0 : _b.en) || "",
                items: selectedMerchandise,
                ...(config.merchandiseUrl &&
                    ((_c = config.fields.postShowEmailMerchCtaLabel.content) === null || _c === void 0 ? void 0 : _c.en) &&
                    !config.fields.postShowEmailMerchDisableCta.content && {
                    ctalabel: (_d = config.fields.postShowEmailMerchCtaLabel.content) === null || _d === void 0 ? void 0 : _d.en,
                    url: config.merchandiseUrl,
                }),
            },
        }),
        main: {
            header: ((_e = config.fields.postShowEmailHeadline.content) === null || _e === void 0 ? void 0 : _e.en) || "",
            body: (_f = config.fields.postShowEmailBody.content) === null || _f === void 0 ? void 0 : _f.en,
            ctalabel: (_g = config.fields.postShowEmailCtaLabel.content) === null || _g === void 0 ? void 0 : _g.en,
            url: (_h = config.fields.postShowEmailCta.content) === null || _h === void 0 ? void 0 : _h.en,
        },
        ...(((_j = config.fields.postRegistrationAlbum.content) === null || _j === void 0 ? void 0 : _j.image) &&
            config.fields.postShowEmailReleaseEnabled.content && {
            streaming: {
                ...config.fields.postRegistrationAlbum.content,
                header: ((_k = config.fields.postShowEmailReleaseHeadline.content) === null || _k === void 0 ? void 0 : _k.en) || "",
                image: (_l = config.fields.postRegistrationAlbum.content) === null || _l === void 0 ? void 0 : _l.image,
            },
        }),
        socials: filteredSocialLinks,
    };
};
exports.getPostShowEmailPreviewData = getPostShowEmailPreviewData;
//# sourceMappingURL=index.js.map